import { render, staticRenderFns } from "./ApplicantResultDetail.vue?vue&type=template&id=150dbd29&"
import script from "./ApplicantResultDetail.vue?vue&type=script&lang=js&"
export * from "./ApplicantResultDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports